interface IAdvertisementTypesBottomSheet {
  saleAgentsBottomSheet: ISaleAgentBottomSheetProps;
  setSaleAgentsBottomSheet: React.Dispatch<
    React.SetStateAction<ISaleAgentBottomSheetProps>
  >;
  refetchGetSaleAgentList?: () => void;
}

const EditDeleteSaleAgentBottomSheet = ({
  saleAgentsBottomSheet,
  setSaleAgentsBottomSheet,
  refetchGetSaleAgentList,
}: IAdvertisementTypesBottomSheet) => {
  const handleEdit = () => {
    setSaleAgentsBottomSheet({
      ...saleAgentsBottomSheet,
      position: true,
      type: 'addEdit',
    });
    refetchGetSaleAgentList && refetchGetSaleAgentList();
  };

  const handleDelete = () => {
    setSaleAgentsBottomSheet(prev => {
      return {
        ...prev,
        position: true,
        type: 'delete',
      };
    });
  };

  return (
    <div className="flex flex-col gap-3 px-3 pb-4">
      <div className="flex items-center gap-2 text-md" onClick={handleEdit}>
        <i className="icon-nameEdit-Square text-xxl text-gray-700" />
        <span>ویرایش اطلاعات</span>
      </div>
      <div
        className="flex items-center gap-2 text-red-600 text-md"
        onClick={handleDelete}
      >
        <i className="icon-nameDelete text-xxl" />
        <span>حذف</span>
      </div>
    </div>
  );
};

export default EditDeleteSaleAgentBottomSheet;
